export const generateKbUrl = (baseUrl: string, pageId: number, applicationId: string): string => {
	const originUrl = new URL(baseUrl).origin;

	const url = new URL(`${originUrl}/servicedesk/customer/kb/view/${pageId}`);
	url.searchParams.append('applicationId', applicationId);

	return url.toString();
};
export const generateRelativeKbUrl = (pageId: number, applicationId: string): string =>
	`kb/view/${pageId}?applicationId=${applicationId}`;

export const generateEditKbUrl = (baseUrl: string, pageId: number): string =>
	`${baseUrl}/pages/editpage.action?pageId=${pageId}`;

export const getKbLinkProps = (el: Element) => {
	const name = String(el.getAttribute('DATA-TITLE'));
	const pageId = String(el.getAttribute('DATA-ID'));
	const baseUrl = String(el.getAttribute('DATA-APPLINK-URL'));
	const applicationId = String(el.getAttribute('DATA-APPLINK-ID'));
	const shareable =
		el.getAttribute('data-shareable') === 'true' ||
		el.getAttribute('data-hidepadlock') === 'true' ||
		false;

	const iframeSrc = `${baseUrl}/plugins/servlet/remotepageview?pageId=${pageId}`;
	const link = generateRelativeKbUrl(Number(pageId), applicationId);
	const editLink = generateEditKbUrl(baseUrl, Number(pageId));

	return {
		iframeSrc,
		link,
		editLink,
		shareable,
		name,
	};
};

export const getAgentFieldProps = (el: Element) => {
	const userAnchor = el.querySelector('.user-hover');

	// satisfy flow
	if (userAnchor instanceof Element) {
		const href = String(userAnchor.getAttribute('href'));

		const accountId = href.substring(href.indexOf('accountId=') + 10);

		return { accountId, displayName: userAnchor.innerHTML, avatarUrl: '' };
	}

	return undefined;
};
